import { prefixObjectValues } from '../utils';

const form = {
  form: 'form',
  specSelect: 'spec',
  aoiSelect: 'aoi',

  cancelBtn: 'cancel-btn',
  submitBtn: 'submit-btn',
  submitError: 'submit-error',
};

export default prefixObjectValues(form, 'aoi-form');
